<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Контакты и&nbsp;данные филиалов</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
          >
            Как попасть
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Давайте заполним контакты проекта и&nbsp;данные филиалов.</p>

            <p>
              В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Данные проекта&raquo;. На&nbsp;появившейся странице
              выберите &laquo;Адреса и&nbsp;контакты&raquo;.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/kontakty-i-dannye-filialov-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="osnovnye-kontakty"
            class="typography__headline2"
          >
            Основные контакты
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              В&nbsp;основных контактах можно заполнить общую информацию для всего проекта. Данные отдельных филиалов
              будут настраиваться дальше.
            </p>

            <p>Эти элементы будут использоваться в&nbsp;созданном сайте, поэтому важно их&nbsp;заполнить.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/kontakty-i-dannye-filialov-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            Как заполните всю нужную информацию, нажмите &laquo;Сохранить&raquo; в&nbsp;самом низу страницы. После
            успешного сохранения увидите в&nbsp;правом верхнем углу уведомление.
          </p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/kontakty-i-dannye-filialov-3.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="dobavlenie-i-redaktsiya-filiala"
            class="typography__headline2"
          >
            Добавление и редактирование филиала
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>
              Теперь можно добавить рабочий филиал, если такой есть. Нажмите &laquo;Добавить новый адрес&raquo;
              в&nbsp;правом верхнем углу страницы.
            </p>

            <p>
              Без него не&nbsp;получится работать с&nbsp;онлайн-записью на&nbsp;услуги. Также данные филиалов клиенты
              смогут посмотреть на&nbsp;сайте просто для информации.
            </p>

            <p>
              Если вы&nbsp;онлайн-бизнес без физического адреса, которому нужна онлайн-запись на&nbsp;услуги,
              то&nbsp;адрес добавить тоже надо. Его просто можно назвать, например, &laquo;Онлайн&raquo;.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/kontakty-i-dannye-filialov-4.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>В&nbsp;появившемся окне заполните данные адреса.</p>

          <FaqArticlesImageModalButton
            image-source="/images/faq/kontakty-i-dannye-filialov-5.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>Название, адрес и&nbsp;часовой пояс работы обязательные для заполнения данные.</p>

            <p>
              Настройкой активности можно быстро скрывать нужный филиал с&nbsp;сайта и&nbsp;отключать его
              от&nbsp;онлайн-записи. По-умолчанию адрес активен.
            </p>

            <p>
              Настройкой активности можно быстро скрывать нужный филиал с&nbsp;сайта и&nbsp;отключать его
              от&nbsp;онлайн-записи.
            </p>

            <p>
              График работы гибко настраивается для каждого дня недели. Выберите активность нужного дня и&nbsp;заполните
              его рабочее время и&nbsp;перерыв.
            </p>

            <p>Как заполните всю нужную информацию, нажмите &laquo;Добавить&raquo; в&nbsp;самом низу окна.</p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/kontakty-i-dannye-filialov-6.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <div class="block-small">
            <p>
              После успешного добавления увидите в&nbsp;правом верхнем углу уведомление и&nbsp;внизу страницы новый
              филиал.
            </p>

            <p>
              Здесь можно посмотреть основную информацию филиала, быстро скрыть его с&nbsp;сайта, перейти
              к&nbsp;редактированию или удалить.
            </p>

            <p>
              С&nbsp;контактами и&nbsp;данными филиалов разобрались. Самое время перейти к&nbsp;настройке
              <BaseLink
                class="ui-link-secondary"
                to="/faq/articles/yazyk-i-region"
                >языка и&nbsp;региона проекта</BaseLink
              >.
            </p>

            <FaqArticlesImageModalButton
              image-source="/images/faq/kontakty-i-dannye-filialov-7.jpg"
              @click="(imageSource) => (activeImageSource = imageSource)"
            />
          </div>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Данные проекта",
    url: "/faq/categories/dannyye-proyekta",
  },
  {
    name: "Контакты и&nbsp;данные филиалов",
  },
];

const menu = [
  {
    name: "Как&nbsp;попасть",
    url: "kak-popast",
  },
  {
    name: "Основные&nbsp;контакты",
    url: "osnovnye-kontakty",
  },
  {
    name: "Добавление&nbsp;и&nbsp;редактирование филиала",
    url: "dobavlenie-i-redaktsiya-filiala",
  },
];

const relatedArticles = [
  {
    name: "Настройка меню CRM",
    slug: "nastroyka-menyu-crm",
  },
  {
    name: "Общие настройки",
    slug: "obshchiye-nastroyki",
  },
  {
    name: "Язык и&nbsp;регион",
    slug: "yazyk-i-region",
  },
  {
    name: "Уведомления",
    slug: "uvedomleniya",
  },
];

useSeoMeta({
  title: "Контакты и данные филиалов",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
